import { useCurrentSessionType } from "@/hooks/use-current-session-type"
import { useAIParserStore } from "@/stores/ai-parser-store"

export function useAIParserSession() {
  // Determine session type from current route path
  const sessionType = useCurrentSessionType()

  const parserStore = useAIParserStore(sessionType)
  const currentSessionId = parserStore((state) => state.currentSessionId)
  const setCurrentSessionId = parserStore((state) => state.setCurrentSessionId)

  return {
    currentSessionId,
    setCurrentSessionId,
    sessionType,
  }
}
